import React, { useEffect } from 'react';
import micAndVideoGraphics from '../../../../../../assets/images/graphics/mic_and_video.svg';
import { Button } from '../../../../../../ui';
import { SecondaryTypography } from '../../../../../../ui/typography/typography';
import commonStyles from '../../assigned_assessments.module.css';
import { BrowserSettingsCard } from '../assessment_instructions_modal/BrowserSettingsCard';
import styles from './enable_cam_mic_modal.module.css';

type EnableCamMicModalProps = {
  setModalContent: (content: number) => void;
};

export const EnableCamMicModal = ({
  setModalContent,
}: EnableCamMicModalProps) => {
  useEffect(() => {
    let stream: MediaStream | null = null;
    let isMounted = true;

    navigator.mediaDevices
      .getUserMedia({ audio: true, video: true })
      .then((mediaStream) => {
        if (isMounted) {
          stream = mediaStream;
          localStorage.setItem('permissions', 'granted');
        } else {
          // Component unmounted before stream was obtained, stop it immediately
          mediaStream.getTracks().forEach((track) => {
            track.stop();
          });
        }
      })
      .catch((error) => {
        console.error(
          '❌ EnableCamMicModal: Error accessing media devices:',
          error,
        );
      });

    // Cleanup: Stop all tracks when component unmounts
    return () => {
      isMounted = false;
      if (stream) {
        stream.getTracks().forEach((track) => {
          track.stop();
        });
      }
    };
  }, []);

  return (
    <div
        className={commonStyles.modalContentContainer}
        style={{ paddingTop: 'unset' }}
    >
      <BrowserSettingsCard />
      <Button
          className='mt-5'
          variant='primary'
          label='Next'
          onClick={() => setModalContent(3)}
      />
    </div>
  );
};
